import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LIVE_LINK } from '../helpers/url_helper'

export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/users` }),
  tagTypes: ['users'],
  endpoints: (build) => ({
    fetchAllUsers: build.query({
      query: () => ({
        url: '/'
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.users.map(({ _id }) => ({ type: 'users', id: _id })), // Provide individual tags for each item
              { type: 'users', id: 'LIST' } // Special tag for the whole list
            ]
          : [{ type: 'users', id: 'LIST' }],
      refetchOnMountOrArgChange: true, // Add this line
    }),
    addUser: build.mutation({
      query: (newRow) => ({
        url: '/',
        method: 'POST',
        body: newRow
      }),
      async onQueryStarted(newRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          usersApi.util.updateQueryData('fetchAllUsers', undefined, (draft) => {
            draft.users.push(newRow); // Optimistically add the new row to the list
          })
        );

        try {
          await queryFulfilled
        } catch {
          patchResult.undo(); // Revert optimistic addition on failure
        }
      },
      invalidatesTags: [{ type: 'users', id: 'LIST' }]
    }),
    updateUser: build.mutation({
      query: (updatedRow) => ({
        url: `/${updatedRow._id}`,
        method: 'PUT',
        body: updatedRow
      }),
      async onQueryStarted(updatedRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          usersApi.util.updateQueryData('fetchAllUsers', undefined, (draft) => {
            const item = draft.users.find((row) => row._id === updatedRow._id);
            if (item) {
              Object.assign(item, updatedRow); // Apply changes optimistically
            }
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic update on failure
        }
      },
      invalidatesTags: (result, error, updatedRow) => [
        { type: 'users', id: updatedRow._id },
        { type: 'users', id: 'LIST' }
      ]
    }),
    deleteUser: build.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE'
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          usersApi.util.updateQueryData('fetchAllUsers', undefined, (draft) => {
            const index = draft.users.findIndex((row) => row._id === id);
            if (index !== -1) {
              draft.users.splice(index, 1); // Remove item optimistically
            }
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic deletion on failure
        }
      },
      invalidatesTags: (result, error, id) => [
        { type: 'users', id },
        { type: 'users', id: 'LIST' }
      ]
    })
  })
});